import {
  createStore as reduxCreateStore,
  applyMiddleware,
  compose,
} from "redux"
import thunk from "redux-thunk"
import isBrowser from "../utils/isBrowser"

const authReducer = (state, action) => {
  switch (action.type) {
    case `SET_USER`:
      return {
        ...state,
        auth: action.data,
      }
    case `LOGIN`:
      return {
        ...state,
        auth: action.data,
        isLoggedIn: true,
      }
    case `ADMIN_PROFILE`:
      return {
        ...state,
        isAdmin: true,
      }
    case `LOGOUT`:
      return {
        ...state,
        auth: undefined,
        isLoggedIn: false,
        isAdmin: false,
      }
    case `SET_WORKOUTS`:
      return {
        ...state,
        workouts: action.data,
      }

    case `SET_PROGRESS`:
      return {
        ...state,
        progress: action.data,
      }
    case `SET_MEAL_PLAN`:
      return {
        ...state,
        mealPlan: action.data,
      }
    case `SET_PROFILE`:
      return {
        ...state,
        profile: action.data,
      }
    case `SET_HEALTH_PROFILE`:
      return {
        ...state,
        healthProfile: action.data,
      }
    case `SET_USER_PROFILES`:
      return {
        ...state,
        userProfiles: action.data,
      }
    case `LOADING`:
      return {
        ...state,
        loading: action.data,
      }

    default:
      return state
  }
}

const initialState = {
  healthProfile:
    isBrowser() && window.localStorage.getItem("healthProfile")
      ? JSON.parse(window.localStorage.getItem("healthProfile"))
      : undefined,
  profile:
    isBrowser() && window.localStorage.getItem("profile")
      ? JSON.parse(window.localStorage.getItem("profile"))
      : undefined,
  loading: false,
  isLoggedIn: isBrowser() && window.localStorage.getItem("auth") ? true : false,
  isAdmin: isBrowser() && window.localStorage.getItem("admin") ? true : false,
  auth:
    isBrowser() && window.localStorage.getItem("auth")
      ? JSON.parse(window.localStorage.getItem("auth"))
      : undefined,
  userProfiles: undefined,
  mealPlan:
    isBrowser() && window.localStorage.getItem("mealPlan")
      ? JSON.parse(window.localStorage.getItem("mealPlan"))
      : undefined,
  progress:
    isBrowser() && window.localStorage.getItem("progress")
      ? JSON.parse(window.localStorage.getItem("progress"))
      : undefined,
  workouts:
    isBrowser() && window.localStorage.getItem("workouts")
      ? JSON.parse(window.localStorage.getItem("workouts"))
      : undefined,
}
// const composeEnhancers =
//   (isBrowser() && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose

const composeEnhancers =
  (typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true,
      traceLimit: 25,
    })) ||
  compose

const createStore = () =>
  reduxCreateStore(
    authReducer,
    initialState,
    composeEnhancers(applyMiddleware(thunk))
  )
export default createStore
